import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a9a9189&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=0a9a9189&lang=scss&scoped=true&"
import style2 from "./index.vue?vue&type=style&index=2&id=0a9a9189&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9a9189",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9a9189')) {
      api.createRecord('0a9a9189', component.options)
    } else {
      api.reload('0a9a9189', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0a9a9189&scoped=true&", function () {
      api.rerender('0a9a9189', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormImageGallery/index.vue"
export default component.exports